import client from '@/store/client'
import qs from 'query-string'
import { parseStringPromise } from 'xml2js'
// import _ from 'lodash'
import parseData from '../util/parsedata'

const getDefaultState = () => {
  return {
    SiteID: '',
    currentPretailer: '',
    promoterListSelected: '',
    CampaignName: '',
    CampaignID: '',
    Description: '',
    CampaignStartDate: '',
    CampaignEndDate: '',
    CampaignDealTypeID: '0',
    BillingEntityID: '26',
    PrimaryContactName: '',
    PrimaryContactEmailAddress: '',
    SecondaryContactName: '',
    SecondaryContactEmailAddress: '',
    editBilling: '',
    newBilling: '',
    campaignTemplates: [],
    templatePretailerID: '',
    templateType: '',
    templateURL: '',
    templateUnitLogo: '',
    templatePageLogo: '',
    templateTagNames: '',
    pretailers: [],
    templateTypes: []
  }
}

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    search: '',
    status: '',
    siteList: [],
    pretailerPromo: [],
    promoterList: [],
    billRecipients: [],
    campaignTypes: [],
    allCampaigns: []
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    GENERATE_CAMPAIGN_ID: async function({ commit }) {
      try {
        const APIRes = await client.post('/v2/Campaign.asmx/GenerateCampaignID')
        const parsedRes = await parseStringPromise(APIRes.data)
        commit('setField', { key: 'CampaignID', value: parsedRes.content.collection[0].data[0].$.CampaignID})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_ALL_CAMPAIGNS: async function({commit, state}){
      try {
        const APIRes = await client.post('/v1/Campaign.asmx/GetCampaignAllForAdmin', qs.stringify({filterActiveInactive: state.status }))
        commit('setAllCampaigns', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_SITE_LIST: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetSiteList')
        commit('setField', { key: 'siteList', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_PROMOTER_LIST: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetPromoterAccountList')
        commit('setField', { key: 'promoterList', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_BILL_RECIPIENT: async function({commit}){
      try {
        const APIRes = await client.post('/v1/CampaignBilling.asmx/GetCampaignBillingEntityList')
        commit('setField', { key: 'billRecipients', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    INSERT_BILLING: async function({commit, state, rootState}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating New Bill Entity',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/CampaignBilling.asmx/InsertCampaignBillingEntity', qs.stringify({BillingEntityName: state.newBilling, userLogon: rootState.user.username}))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `New Billing Entity Created`, color: 'green', delay: 2500 })
        commit('setField', { key: 'newBilling', value: ''})

      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    SET_BILL_EDITING: function({commit, state}, data) {
      if (state.editBilling == ''){
        commit('setField', { key: 'editBilling', value: data.text })
        commit('updatedBillingList', data.value)
      } else {
        this.dispatch('ui/SET_TOAST', { message: `Only one item can be edited at a time`, color: 'error', delay: 2500 })
      }
    },
    UPDATE_BILLING: async function({commit, rootState}, data) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...data,
          userLogon: rootState.user.username
        }
        await client.post('/v1/CampaignBilling.asmx/UpdateCampaignBillingEntity', qs.stringify(APIData))
        await this.dispatch('campaigns/GET_BILL_RECIPIENT')
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        commit('setField', { key: 'editBilling', value: ''})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_CAMPAIGN_TYPE: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetCampaignDealTypes')
        commit('setField', { key: 'campaignTypes', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_CAMPAIGN: async function({commit}, data){
      try {
        const APIRes = await client.post('/v1/Campaign.asmx/GetCampaign', qs.stringify({ campaignID: data.ID}))
        const parsedRes = await parseStringPromise(APIRes.data)
        commit('setCampaign', parsedRes.content.collection[0].data[0].$)
        commit('setField', { key: 'SiteID', value: data.siteID })
        commit('setField', { key: 'currentPretailer', value: data.pretailer })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    UPDATE_CAMPAIGN: async function() {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Campaign',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Campaign.asmx/UpdateCampaign', qs.stringify(this.getters['campaigns/updateCampaign']))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Campaign has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    UPDATE_CAMPAIGN_SITE: async function() {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Campaign Site',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Campaign.asmx/UpdateCampaignPRetailerOrCampaignSite', qs.stringify(this.getters['campaigns/updateCampaignSite']))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Campaign Site has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    INSERT_CAMPAIGN: async function() {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Campaign.asmx/InsertCampaign', qs.stringify(this.getters['campaigns/updateCampaign']))
        await client.post('/v1/Campaign.asmx/InsertCampaignPRetailerOrCampaignSite', qs.stringify(this.getters['campaigns/insertPRetailerSite']))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Campaign has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_CAMPAIGN_TEMPLATES: async function ({commit, state}) {
      try {
        const APIRes = await client.post('/v1/Campaign.asmx/GetCampaignTemplates', qs.stringify({ campaignID: state.CampaignID}))
        commit('setField', { key: 'campaignTemplates', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_PRETAILERS: async function ({commit, state}) {
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetPretailerPromotionTypeBySite', qs.stringify({ SiteID: state.SiteID}))
        commit('setField', { key: 'pretailers', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_TEMPLATE_TYPE: async function ({commit}) {
      try {
        const APIRes = await client.post('/v2/Campaign.asmx/FindCampaignTemplateType')
        commit('setField', { key: 'templateTypes', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    SAVE_CAMPAIGN_TEMPLATE: async function() {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Template',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Campaign.asmx/SaveCampaignTemplates', qs.stringify(this.getters['campaigns/saveTemplateData']))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Template has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    DELETE_CAMPAIGN_TEMPLATE: async function({rootState}, data) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Template',
          subdetail: 'Please wait...',
        })
        const APIData = {
          campaignID: data.CampaignID,
          pretailerID: data.PRetailerID,
          campaignTemplateTypeID: data.CampaignTemplateTypeID,
          campaignTemplateURL: data.CampaignTemplateURL,
          retailerTagNames: data.RetailerTagNames,
          logonName: rootState.user.username
        }
        await client.post('/v1/Campaign.asmx/DisableCampaignTemplates', qs.stringify( APIData ))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Template has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    SET_CURRENT_TEMPLATE: async function({commit}, data){
      commit('setCurrentTemplate', data)
    },
    GET_PRETAILER_PROMO: async function({commit}, data) {
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetPretailerPromotionTypeBySite', qs.stringify({ SiteID: data }))
        commit('setField', { key: 'pretailerPromo', value: await parseData(APIRes.data)})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
  },
  getters: {
    campaignTemplates: (state) => {
      if(!state.campaignTemplates) return []
      return state.campaignTemplates.map( item => {
        item.displayName = `${ item.PRetailerName } (${ item.PRetailerID })`
        return item 
      })
    },
    pretailers: (state) => {
      return state.pretailers.map( item => {
        return { text: `${item.PRetailerName} (${item.PRetailerID})`, value: item.PRetailerID }
      })
    },
    allCampaigns: (state) => {
      return state.allCampaigns.map( item => {
        // if (!item.CampaignStartDate) return item
        const startDate = item.CampaignStartDate.split('/',3)
        const endDate = item.CampaignEndDate.split('/', 3)
        item.CampaignStart = `${startDate[2]}/${startDate[0]}/${startDate[1]} ${item.CampaignStartTime}`
        item.CampaignEnd = `${endDate[2]}/${endDate[0]}/${endDate[1]} ${item.CampaignEndTime}`
        return item
      })
    },
    siteList: (state) => {
      return state.siteList.map( item => {
        return { text: item.Code, value: item.ID }
      })
    },
    promoterList: (state) => {
      return state.promoterList.map( item => {
        return { text: item.Name, value: item.ID }
      })
    },
    billRecipients: (state) => {
      return state.billRecipients.map( item => {
        return { text: item.BillingEntityName, value: item.BillingEntityID, editing: item.editing }
      })
    },
    campaignTypes: (state) => {
      return state.campaignTypes.map( item => {
        return { text: item.CampaignDealTypeDescription, value: item.CampaignDealTypeID }
      })
    },
    templateTypes: (state) => {
      return state.templateTypes.map( item => {
        return { text: item.CampaignTemplateTypeDescription, value: item.CampaignTemplateTypeID }
      })
    },
    updateCampaign: (state, getters, rootState) => {
      return {
        logonName: rootState.user.username,
        campaignStatus: 'n',
        apiVersion: '',
        partnerFirm: '',
        campaignName: state.CampaignName,
        primaryContactName: state.PrimaryContactName,
        campaignDealTypeID: state.CampaignDealTypeID,
        campaignID: state.CampaignID,
        campaignEndDate: state.CampaignEndDate,
        campaignStartDate: state.CampaignStartDate,
        primaryContactEmailAddress: state.PrimaryContactEmailAddress,
        BillingEntityID: state.BillingEntityID,
        description: state.Description,
        secondaryContactName: state.SecondaryContactName,
        secondaryContactEmailAddress: state.SecondaryContactEmailAddress
      }
    },
    updateCampaignSite: (state, getters, rootState) => {
      return {
        logonName: rootState.user.username,
        promoterAccountID: '',
        pRetailerID: '',
        siteID: state.SiteID,
        campaignID: state.CampaignID,
      }
    },
    insertPRetailerSite: (state, getters, rootState) => {
      return {
        logonName: rootState.user.username,
        pRetailerID: '',
        siteID: state.SiteID,
        campaignID: state.CampaignID,
        promoterAccountID: state.promoterListSelected
      }
    },
    saveTemplateData: (state, getters, rootState) => {
      return {
        logonName: rootState.user.username,
        campaignID: state.CampaignID,
        campaignPageLogo: state.templatePageLogo,
        adunitLogo: state.templateUnitLogo,
        pretailerID: state.templatePretailerID,
        campaignTemplateTypeID: state.templateType,
        campaignTemplateURL: state.templateURL,
        retailerTagNames: state.templateTagNames
      }
    },
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setCampaign(state, data) {
      Object.keys(state).forEach(k => state[k] = data[k] || state[k])
    },
    setAllCampaigns: function(state, data) {
      state.allCampaigns = data
    },
    updatedBillingList: function(state, data) {
      state.billRecipients = state.billRecipients.map( item => {
        if (item.BillingEntityID == data ) item.editing = !item.editing
        return item
      })
    },
    setCurrentTemplate: function(state, data){
      state.templatePretailerID = data.PRetailerID
      state.templateType = data.CampaignTemplateTypeID
      state.templateURL = data.CampaignTemplateURL
      state.templateUnitLogo = data.AdUnitRetailerLogo
      state.templatePageLogo = data.CampaignPageRetailerLogo
      state.templateTagNames = data.RetailerTagNames
    }
  },
}
